import Gudang from './gudang.route';
import Penjualan from './penjualan.route';
import Kasir from './kasir.route';
import Admin from './admin.route';

let kantor_pelayanan = [];

kantor_pelayanan = kantor_pelayanan.concat(
    Admin.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Admin'
        }
    })),
    Gudang.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Gudang'
        }
    })),
    Kasir.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Kasir'
        }
    })),
    Penjualan.map(route => ({
        ...route,
        meta: {
            ...route.meta,
            parent: 'Penjualan'
        }
    })),
);

export default kantor_pelayanan;
